import { Text, Container, cn, Link } from '@artprov/design-system'
import BackButton from '../nomina/components/backButton'

export default function HelpDesk() {
  const urlManualUsuario =
    import.meta.env.VITE_API_CDN ||
    'https://www.provinciart.com.ar/descargables-web/ed9d05d5-b195-473e-a8a9-c5653c710042.pdf'

  return (
    <div className="w-full hidden sm:flex flex-col">
      <div className="w-full px-8 lg:px-24 mt-4">
        <BackButton />
        <section className="pt-8 pb-5">
          <Text variant="h6" className="text-primary-20">
            Centro de Ayuda
          </Text>
          <div className="mt-4">
            <Container className="w-full ">
              <div className={cn('w-full bg-tertiary-100 flex justify-between p-4 rounded flex-wrap gap-1 h-auto')}>
                <div className={cn('flex w-fit items-center')}>
                  <Text variant="h6" className="text-primary-10 px-2 pl-0">
                    Manual de usuario
                  </Text>
                </div>
                <div className="w-full">
                  <div className="border-t  bg-primary-10 border-primary-10"></div>
                  <div className="mt-2">
                    <Link href={urlManualUsuario} variant="link1" className="pl-0 mt-4" target="_blank">
                      Descargar guía para utilizar la plataforma
                    </Link>
                  </div>
                </div>
              </div>
            </Container>
          </div>
        </section>
      </div>
    </div>
  )
}
